import React, { forwardRef } from "react";
import { DateIcon } from "../icon/icon";

const CustomDateInput = forwardRef((props, ref) => {
  const { icon, className, value, onChange, onClick } = props;
  return (
    <div className={`fog_custom_date_picker_input ${className}`}>
      <input
        readOnly
        ref={ref}
        type="text"
        value={value}
        onClick={onClick}
        onChange={onChange}
      />
      <span className="date-icon ms-0" onClick={onClick}>
        {icon ? icon : DateIcon}
      </span>
    </div>
  );
});

export default CustomDateInput;
